import { z } from "zod";

const zoneTypes = ["field", "spectator", "parking", "facility"] as const;

export const createZoneSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  zone_type: z.enum(zoneTypes, { message: "Invalid zone type" }),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
});

export const updateZoneSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  zone_type: z.enum(zoneTypes, { message: "Invalid zone type" }).optional(),
  latitude: z.number().min(-90).max(90).nullable().optional(),
  longitude: z.number().min(-180).max(180).nullable().optional(),
});

export type CreateZoneInput = z.infer<typeof createZoneSchema>;
export type UpdateZoneInput = z.infer<typeof updateZoneSchema>;
